import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Image from '@hfe/max-image';
import Text from '@hfe/max-text';
import './Button.scss';
import { getImage, photos } from "../../utils/common";
function Button(p) {
    const showPrice = () => {
        return !!p.actualPrice || !!(p === null || p === void 0 ? void 0 : p.averagePrice);
    };
    return <>
      {showPrice() && <View className="button-container">
          <Image className="button-bg" source={getImage(photos.button_bg)}/>
          <View className="button-text-container">
            <Text className="button-RMB">¥</Text>
            <Text className="button-actual-price">{p.actualPrice || (p === null || p === void 0 ? void 0 : p.averagePrice)}</Text>
            <Text x-if={!(p === null || p === void 0 ? void 0 : p.averagePrice)} className="button-char-qi">起</Text>
            {p.originalPrice && p.actualPrice !== p.originalPrice && <Text className="button-original-price">¥{p.originalPrice}</Text>}
            <View x-if={p.reducedPrice} className="button-reduced-price-container">
              <Text className="button-reduced-price">{p.reducedPrice}</Text>
            </View>
            <Text className="button-buy">{p.buyText}</Text>
          </View>
        </View>}
    </>;
}
export default memo(Button);
